

export const index = 1;
export const component = async () => (await import('../entries/fallbacks/error.svelte.js')).default;
export const file = '_app/immutable/components/error.svelte-a93fb160.js';
export const imports = ["_app/immutable/components/error.svelte-a93fb160.js","_app/immutable/chunks/index-d33e9054.js","_app/immutable/chunks/singletons-95ebab62.js","_app/immutable/chunks/index-386f2693.js"];
export const stylesheets = [];
